import React, { useState } from 'react';
import ProfileInfo from '../components/ProfileInfo';
import { useStores } from '../stores';
import MyAddresses from '../components/MyAddresses';
import EmailComunication from '../components/EmailComunication';
import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { sitesId } from '../../../stores/Constants';
import Privacy from './Privacy';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    paddingTop: '32px',
    paddingBottom: '40px',
    fontSize: 30,
    fontWeight: 600,
    margin: 0,
    color: theme.customPalette.darkishPurple,
    [theme.breakpoints.up('sm')]: {
      paddingTop: '56px',
    },
  },
  alertCompleteProfileContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #396DCF',
    padding: '16px 18px',
    color: '#396DCF',
    backgroundColor: 'rgba(204, 204, 204, 0.1)',
    marginBottom: '40px',
  },
  alertCompleteProfileWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginLeft: '8px',
  },
  alertCompleteProfileTitle: {
    fontSize: '20px',
    fontWeight: 600,
  },
  alertCompleteProfileText: {
    fontSize: '14px',
    fontWeight: 500,
    marginTop: '8px',
  },
}));

const Profile = ({ hasIncompleteProfile }) => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'components', 'validations']);
  const [actionsEnabled, setActionsEnabled] = useState(true);
  const { numverifyStore, userStore } = useStores();
  const { user } = userStore;
  const handleExpansion = (expaded) => {
    setActionsEnabled(!expaded);
    numverifyStore.setShowPhoneError(false);
  };

  return (
    <Container>
      <h2 className={classes.mainTitle}>
        {t('components:ProfileInfo.mainTitle')}
      </h2>
      {hasIncompleteProfile && (
        <div className={classes.alertCompleteProfileContainer}>
          <div className={classes.alertCompleteProfileWrapper}>
            <InfoOutlined fontSize="large"></InfoOutlined>
            <span className={classes.alertCompleteProfileTitle}>
              {t('common:completeProfileTitle')}
            </span>
          </div>
          <span className={classes.alertCompleteProfileText}>
            {t('common:completeProfileSubtitle')}
          </span>
        </div>
      )}
      <ProfileInfo
        id={'profile'}
        actionsEnabled={actionsEnabled}
        onEdit={handleExpansion}
        expanded={hasIncompleteProfile}
      />
      <MyAddresses
        id={'profile'}
        actionsEnabled={actionsEnabled}
        onEdit={handleExpansion}
      />
      {user.acquisitionOwner === sitesId.us && (
        <EmailComunication
          id={'profile'}
          actionsEnabled={actionsEnabled}
          onEdit={handleExpansion}
        />
      )}
      {user.acquisitionOwner !== sitesId.us && <Privacy />}
    </Container>
  );
};

export default Profile;
